<template>
  <div>
    <div class="d-flex CARD">
      <a @click.prevent="edit" class="PAUSED-LEADS-LIST-ITEM flex-1-1">
        <div class="d-flex flex-1-1 fd-column p-l-2 p-y-1">
          <transition name="FADE" mode="out-in">
            <div>
              <div class="d-flex jc-between">
                <div class="text-underline text-bold m-b-1 h6" >Pause - {{ occupationName }}</div>
                <div class="flex-0-0 m-x-0:mo">
                  <vk-listbox
                      display-text="..."
                      class="OPTIONS"
                      menuClass="MENU"
                      @input="handleSelection">
                    <vk-listbox-option
                        v-for="(option, index) in options"
                        class="OPTION bd-x-gray50 text-bold"
                        :class="{
                          'bd-t-gray50':index === 0,
                          'c-depot':index ===options.length -1
                        } "
                        :key="index + option"
                        :value="option">
                      {{ option }}
                    </vk-listbox-option>
                  </vk-listbox>
                </div>
              </div>
              <div class="text-md d-flex">
                <div class="d-flex fd-column ITEM-SECTION">
                  <span class="text-bold">Starts</span>
                  <span>{{ formattedDate(pause.startDate) }}</span>
                </div>
                <div class="d-flex fd-column ITEM-SECTION">
                  <span class="text-bold">Ends</span>
                  <span>{{ formattedDate(pause.endDate) }}</span>
                </div>
                <div class="text-right:t">
                  <div class="m-r-3 c-gray60 text-md">
                    Set On: {{ formatDate(pause.createdDTM) }}
                  </div>
                  <div class="m-r-3 c-gray60 text-md">
                    Last Modified: {{ formatDate(pause.modifiedDTM) }}
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </a>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { format, startOfDay } from 'date-fns';

export default {
  name: 'day-paused-list-item',
  props: {
    id: [String, Number],
    pause: Object,
  },
  data () {
    return {
      options: ['Edit', 'Delete'],
    };
  },
  computed: {
    ...mapGetters('account/pro', [
      'serviceProviderCatalogOccupations',
    ]),
    occupationName () {
      if (this.pause.serviceProviderOccupationId) {
        return this.serviceProviderCatalogOccupations[this.pause.serviceProviderOccupationId]
          .occupation.display_name;
      }
      return `All Occupations (${Object.keys(this.serviceProviderCatalogOccupations).length})`;
    },
    startDate () {
      return format(startOfDay(new Date(`${this.pause.startDate}T00:00:00`)), 'MMM dd, yyyy');
    },
    endDate () {
      return `- ${format(startOfDay(new Date(`${this.pause.endDate}T00:00:00`)), 'MMM dd, yyyy')}`;
    },
  },
  methods: {
    handleSelection (selectedOption) {
      switch (selectedOption) {
        case 'Edit':
          this.$events.$emit(this.$events.PAUSE_DOTS_DELETE_CLICK);
          this.edit();
          break;
        default:
          this.$events.$emit(this.$events.PAUSE_DOTS_EDIT_CLICK);
          this.deletePause();
      }
    },
    edit () {
      this.$emit('onEdit', this.pause);
    },
    deletePause () {
      this.$emit('onDelete', this.pause);
    },
    formattedDate (date) {
      return format(new Date(date.replace(/-/g, '/')), 'MMM dd, yyyy');
    },
    formatDate (date) {
      return format(new Date(date), 'MMM d, p');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  @import "~@/views/Dashboard/constants";
  @import "~@/views/Dashboard/tools";

  .PAUSED-LEADS-LIST-ITEM {
    @include hover(text-decoration, none, none);
    @include desktop-hover(background-color, transparent, $color-gray20);
    @include pseudo(visited, color, $color-gray80, $color-gray80);
    display: flex;
    flex: 0 0 auto;
    background-color: white;
    will-change: background-color;
    transition: background-color $transition-half-duration;

    cursor: pointer;
    @include mobile-only () {
      width:90vw;
    }
  }
  .CARD {
    flex: 1 1 auto;
    justify-content: space-between;
    border-left: solid 6px $color-gray40;
    border-bottom: 1px solid $color-gray30;
  }
  .EDIT {
    font-weight: 400;
    color : #3E7697
  }
  .TIME {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    width: 14.25 * $unit;
    padding-right: 2*$unit;
    border-right: 6px solid $color-gray50;
    text-align: left;
    white-space: nowrap;
  }
  .OPTIONS {
    @include text-medium;

    /deep/ .input {
      width: 50px;
      padding: 0;
      border: none;
      font-weight: 700;
      font-size: 34px;
      color: $color-depot;
      font-family: serif;
      align-items: start;
      margin-left: $unit;

      .VK-LISTBOX-TEXT {
        padding-right: $unit;
      }

      .CHEVRON {
        color: transparent;
      }
    }

    /deep/ .MENU {
      top: 3*$unit;
      right: 0;
      height: auto;
      width: 100px;
      padding: $unit 0;
      border: none;
      overflow: auto;
      background-color: transparent;
    }
  }
  .OPTION {
    background-color: white;
    border-bottom: solid 1px $color-gray50;
    @include hover(transform, none, none);
    transition: none;
  }
  .ITEM-SECTION {
    max-width: 180px;
    flex: 1 1 auto;
  }
</style>
